<rt-select2
  #select
  [formControl]="control()"
  [rtProtectedControl]="control()"
  [searchControl]="searchControl"
  [disableLocalSearch]="disableLocalSearch()"
  [items]="selectOptions()"
  [disabled]="isReadOnly()"
  [hiddenItems]="selectedItems()"
  withSearch
  withMultiselect
  (vsUpdate)="scrollChange.emit($event)"
  (selection)="onSelectChange($event)"
>
  <rt-select-trigger-multi
    [isInvalid]="isInvalid()"
    [placeholder]="'app.common.select' | translate"
    [disabled]="isReadOnly()"
    [extendedPreviewInOverlay]="hasExtendedPreview()"
  />
  <ng-template
    [rtSelectSelectedItem]="select"
    let-remove="remove"
    let-item="item"
    let-showRemoveIcon="showRemoveIcon"
  >
    <rt-chips
      [text]="item.label"
      [showClose]="showRemoveIcon"
      (close)="remove(item)"
      class="chips-item"
    >
      <ng-container prefix>
        @if (item?.hasAvatar || item?.initials) {
          <rt-avatar
            [type]="item?.hasAvatar ? 'image' : 'initials'"
            [imageSrc]="item?.photoThumbUrl || null"
            [initials]="$safeNavigationMigration(item?.initials)"
            size="small-x"
            context="admin"
          />
        }
      </ng-container>
    </rt-chips>
  </ng-template>
  <ng-template rtSelectSelectedItemCounter let-hiddenCount="hiddenCount">
    <rt-chips [text]="'+' + hiddenCount" [showClose]="false" class="chips-item" />
  </ng-template>
  <ng-template
    [rtSelectListItem]="select"
    let-selectCtrl
    let-item="item"
    let-isHoverState="isHoverState"
  >
    <rt-dropdown-item (click)="selectCtrl.select$.next(item)" [class.hover]="isHoverState">
      <rt-checkbox
        prefix
        [checked]="selectCtrl.itemSelector.isSelected(item)"
        [hasMargin]="false"
        (valueChange)="selectCtrl.select$.next(item)"
      />

      <div layout-vertical>
        <div layout layout-align-items-center>
          @if (item?.hasAvatar || item?.initials) {
            <rt-avatar
              [type]="item?.hasAvatar ? 'image' : 'initials'"
              [imageSrc]="item?.photoThumbUrl || null"
              [initials]="$safeNavigationMigration(item?.initials)"
              size="small-x"
              context="admin"
              margin-right-small-xx
              prefix
            />
          }
          {{ item.label }}
        </div>
      </div>
    </rt-dropdown-item>
  </ng-template>
  <ng-template rtSelectEmptyState>
    <rt-dropdown-item>
      {{ noResultsMessage() }}
    </rt-dropdown-item>
  </ng-template>
</rt-select2>
